<template>
  <div class="full">

    <section class="full relative">
      <GLArtCanvas :rounded="'0px 0px 0px 0px'" class="full absolute top-0 left-0" style="z-index: -1;" bgcolor="#000000">
        <!-- <MBLinesBloom :pz="-20" :scale="{ x: 1.2, y: 1.2, z: 1.2 }"></MBLinesBloom> -->
        <Bloomer :settings="{
          exposure: 1.0,
          bloomStrength: 2,
          bloomThreshold: 70.72 / 100.0,
          bloomRadius: 80.99 / 100.0 * 2
        }"></Bloomer>
        <!-- <GLFlower :pz="20"></GLFlower> -->
        <GradientBG :pz="-20"></GradientBG>
        <Halo :pz="-20"></Halo>
        <!-- <FastFlame :lowres="true" :sy="1 * 2" :sx="3.6 * 2"></FastFlame> -->
      </GLArtCanvas>

      <div class="full overflow-scroll scrolling-touch"  style="background-color: rgba(0,0,0,0.5)">

        <div class="mx-auto max-w-3xl py-12 px-6 text-white text-center whitespace-pre-line">
  <span class="text-4xl">樂創人生</span>

光環象徵天使，不過墮落了便成了惡魔。
人也一樣會有精神健康問題，不過有老天爺的眷顧，總有機會重新出發。

以下是樂樂的個人故事，以及心路歷程，希望能鼓勵他人。

由高考不及格，零收入，去到做了Webbys Awards評委和贏了30萬創業比賽。
由自己和家人在醫院過生日，去到78個happy birthday comments。
由失去很多“朋友”，去到找回自己，認識自己。

一路走過來，發現人生滿是希望和喜悅，愛家人，愛自己的生命。
別人對你差，自己對自己好。不要反彈別人對你作出的傷害，冤冤相報絕對不是一個人生的遊戲。
言語和文字皆有權能，可以建立一個人的愛和人生，也可以令一個人想放棄生命。
在成功之前，老天爺會好好準備每一個相信愛的人，愛是有耐性的，對其他人有耐性，對自己也要有耐性。
沒有人天生完美，尤其是抑鬱症的康復者。
自怨自艾是一個坑，創造未來是一個往天堂的升降機。

用雙手創新，為美好的生活奮鬥。
        </div>
      </div>

    </section>

    <section v-if="false" class="text-gray-700 body-font max-w-5xl mx-auto">
      <div class="container px-5 py-24 mx-auto flex flex-wrap">
        <div class="flex flex-wrap w-full">
          <div class="w-full rounded-lg md:mt-0 mt-12">
            <div class="course-catalogue-art rounded-lg ">
              <GLArtCanvas class="h-full w-full rounded-lg" :rounded="'8px 8px 8px 8px'">
                <!-- <Bloomer :settings="{
                  exposure: 1.0,
                  bloomStrength: 1.7,
                  bloomThreshold: 20.72 / 100.0,
                  bloomRadius: 72.99 / 100.0 * 2
                }"></Bloomer> -->

                <GLFlower></GLFlower>

                <!-- <EnergyArt :pz="50" :lowres="true"></EnergyArt> -->
                <!-- <FastFlame :sx="3.6" :lowres="true"></FastFlame> -->
              </GLArtCanvas>
            </div>
          </div>
          <!-- <img class="lg:w-3/5 md:w-1/2 object-cover object-center rounded-lg md:mt-0 mt-12" src="https://dummyimage.com/1200x500" alt="step"> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Core/O3DVue').O3DVue
  ],
  data () {
    return {
    }
  },
  mounted () {
    require('../EventSpaceV2/loadAmmo.js').loadAmmo()
  }
}
</script>

<style lang="postcss">
.course-banner{
  height: 60vh;
}
.course-banner-overlay{
  background-color: rgba(0, 0, 0, 0.185);
}

.course-catalogue-art{
  position: sticky;
  top: 30px;
  height: 550px;
  background-image: url(./img/cherry.jpg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat no-repeat;
  background-color: #142f79;
}
/* @screen lg{
  .course-catalogue-art{
    height: 100%;
  }
} */
</style>